/**
 * Expands all symbols in the format `{env:VAR_NAME}` with the value of the environment variable `VAR_NAME`.
 * If no such environment variable is set, the symbol is replaced with an empty string.
 * Symbols without the `env:` prefix are not replaced.
 *
 * @param config Any JSON object, but typically an AppConfig object
 */
export function expandEnvironmentVariables(config: Record<string, unknown>): void {
  for (const [key, value] of Object.entries(config)) {
    if (typeof value === 'string') {
      // Valid environment variable names must start with a letter or underscore and can only contain letters, numbers, and underscores.
      const matches = value.matchAll(/\{env:([A-Za-z_][A-Za-z0-9_]*)\}/g);
      for (const match of matches) {
        // eslint-disable-next-line no-restricted-properties -- standard env properties aren't relevant here
        config[key] = (config[key] as string).replace(match[0], process.env[match[1]] ?? '');
      }
    } else if (typeof value === 'object') {
      expandEnvironmentVariables(value as Record<string, unknown>);
    }
  }
}
